import { inject } from 'vue'
import NotificationService, { NotificationServiceKey } from 'src/services/NotificationService'

export function useNotificationService (): NotificationService {
  const service = inject(NotificationServiceKey)
  if (!service) {
    throw new Error('NotificationService is not provided')
  }
  return service
}
